import { render } from "./markPhoto.vue?vue&type=template&id=21239fd2&scoped=true"
import script from "./markPhoto.vue?vue&type=script&lang=js"
export * from "./markPhoto.vue?vue&type=script&lang=js"

import "./markPhoto.vue?vue&type=style&index=0&id=21239fd2&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21239fd2"]])

export default __exports__